<script setup lang="ts">
import { makeLink } from '../js-utils/_shared/utils';
const props = defineProps<{
    mode: 'lib' | 'html' | 'dev';
    pageName: string;
}>();
</script>

<template>
    <div class="header">
        <div class="col">Header</div>
        <a class="col" :href="makeLink('index', props.mode)">Índice</a>
    </div>
</template>
<style scoped lang="scss">
.header {
    display: flex;
    justify-content: start;
    align-items: center;
    padding: 10px 20px;
    background-color: #5e7da2;
    gap: 100px;
    margin-bottom: 40px;
    a {
        font-weight: bold;
    }
    div {
        font-size: 1.3em;
    }
    .col {
        margin-right: 20px;
        color: white;
    }
}
</style>
